module.exports = __webpack_public_path__ + "img/img_title.eccfc8ae.png";